import { useMsal } from '@azure/msal-react';
import React, { useState, useEffect } from 'react';
import { getAzureUser } from '../../../API/User/User';

const WelcomeUser = () => {

    const context = useMsal();

    const [user, setUser] = useState({});

    useEffect(() => {
        const getUserData = async () => {
            const user = await getAzureUser(context);
            setUser(user);
        };
        if(context.inProgress === "none"){
            getUserData();
        }
    }, [context]);

    return (
        <div className="d-center h-75 d-flex align-items-center justify-content-center ps-5 ms-5">
            <div className="row pt-5">
                <div className="col-xl-4 col-lg-4 col-md-4">
                    <img src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/NoSubscriptionImage.png`} alt="responsive webite" className="img-fluid" />
                </div>
                <div className="col-xl-8 col-lg-8 col-md-8 pt-5 ps-5">
                    <div className='h-25'></div>
                    <h2 className="mb-1">Welcome to Codeless ONE, {user && user.name}</h2>
                    <h5 className="lead mt-3">
                        To get started, please contact your administrator to assign you a subscription.
                    </h5>
                </div>
            </div>
        </div>
    );
}

export default WelcomeUser;